import React, { useEffect } from 'react';

import { noop } from 'lodash-es';

import usePreventBodyScroll from 'hooks/use-prevent-body-scroll';
import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';

import { IDrawerProps } from './interfaces';
import {
  DrawerContainer,
  MobileOptimizedDrawerContent,
  Overlay,
  StyledCloseButton,
} from './styled';

const Drawer = ({
  allowsDismiss = true,
  className,
  children,
  onDismiss,
  isVisible = true,
  disableScroll,
  ...props
}: IDrawerProps) => {
  usePreventBodyScroll();

  const { logEvent = noop } = useMParticleContext();
  const { mParticleEventData } = props;

  useEffect(() => {
    if (isVisible && mParticleEventData) {
      const { modalMessage, modalAppearanceEventMessage } = mParticleEventData;
      logEvent(CustomEventNames.MODAL_APPEARANCE, EventTypes.Other, {
        Message: modalAppearanceEventMessage,
        ModalMessage: modalMessage,
      });
    }
  }, [isVisible, logEvent, mParticleEventData]);

  return (
    <DrawerContainer disableScroll={disableScroll}>
      <Overlay onClick={onDismiss} />
      <MobileOptimizedDrawerContent
        className={className}
        role="dialog"
        aria-labelledby="drawer-heading"
        disableScroll={disableScroll}
        isVisible={isVisible}
        {...props}
      >
        {allowsDismiss && <StyledCloseButton onClick={onDismiss} />}
        {children}
      </MobileOptimizedDrawerContent>
    </DrawerContainer>
  );
};

export { Drawer };
